module.exports = "/_next/static/images/4ebe227a75a975d6e1dfe5f6070c6351-for-who-xs.jpg.webp";